import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/beneficiaryChange';
// errorDialog跳dialog , repeatRequestCancel可以重複請求
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得銀行的總行下拉選單
export function getBankInfo() {
    return get(`${url}/bankInfo`);
}

// 取得銀行的分行下拉選單
export function postBranchBankInfo(data) {
    return post(`${url}/branchBankInfo`, { bankNo: data });
}

export function postRelation4() {
    return post(`${url}/relation4`);
}

// 保戶進入申請受益人變更預約, 受益人資訊
export function getInfo() {
    return get(`${url}/info`);
}

// 送出受益人預約視訊申請
export function postSubmit(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
